/*
 * ParticipantList.jsx 05.12.2017
 *
 * (c) 2017 ergovia GmbH
 */
import React from 'react';

import { withRouter } from 'react-router';
import { withStyles } from '@material-ui/core/styles';
import NavigateNext from '@material-ui/icons/NavigateNext';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell/TableCell';
import TableRow from '@material-ui/core/TableRow';
import Typography from '@material-ui/core/Typography';
import {COLOR_CODE_NEUTRAL} from '../../styles/colors';
import ParticipantListItemContainer from '../../containers/participants/ParticipantListItemContainer';

const styles = theme => ({

    rootParticipantName: {
        borderBottom: '0',
        whiteSpace: 'nowrap',
        width: '600px',
        maxWidth: '600px',

        [theme.breakpoints.down(1600)]: {
            width: '500px',
            maxWidth: '500px'
        },
        [theme.breakpoints.down(1400)]: {
            width: '400px',
            maxWidth: '400px'
        },
        [theme.breakpoints.down(1200)]: {
            width: '300px',
            maxWidth: '300px'
        }
    },
    rootDefault: {
        textAlign: 'center',
        borderBottom: '0'
    },
    paddingParticipantName: {
        padding: '17px 25px'

    },
    paddingDefault: {
        padding: '17px 0px',
        textAlign: 'center'
    },
    tableRow: {
        cursor: 'pointer',
        '&:hover': {
            background: COLOR_CODE_NEUTRAL
        }
    },
    textEllipsis: {
        overflow: 'hidden',
        textOverflow: 'ellipsis'
    }
});

/**
 * Komponente für die Darstellung einer Teilnehmerliste
 */
class ParticipantListBody extends React.Component {

    /**
     * Registriert einen Listener "focus": Wenn das Browser-Fenster in den Vordergrund geholt wird,
     * dann sollen die Teilnehmerdaten in der Liste aktualisiert werden.
     */
    constructor() {
        super();
        this.focusListener = this.refetchParticipants.bind(this);
        window.addEventListener('focus', this.focusListener);
    }

    /**
     * Deregistriert den Listener auf das Browser-Fenster, wenn die Komponente abgeräumt wird.
     */
    componentWillUnmount() {
        window.removeEventListener('focus', this.focusListener);
    }

    /**
     * Löst einen Apollo-Refetch der Teilnehmerdaten aus.
     */
    refetchParticipants() {
        this.props.refetchParticipants();
    }

    onSelect(selection) {
        this.props.selectParticipant(selection);

        const location = {
            pathname: `participant/${selection.id}`
        };

        this.props.history.push(location);
    }

    render() {
        const {selectedParticipant, classes} = this.props;

        return (
            <TableBody>
                {this.props.participants.map(p =>
                    <TableRow className={classes.tableRow} selected={selectedParticipant && selectedParticipant.id === p.id} onClick={() => this.onSelect(p)} key={p.id}>
                        <TableCell padding="none" classes={{paddingNone: classes.paddingDefault, root: classes.rootDefault}}>
                            {selectedParticipant && selectedParticipant.id === p.id && <NavigateNext/>}
                        </TableCell>
                        <TableCell padding="none" classes={{paddingNone: classes.paddingParticipantName, root: classes.rootParticipantName}}>
                            <Typography className={classes.textEllipsis}>{p.nachname}, {p.vorname}</Typography>
                        </TableCell>
                        <ParticipantListItemContainer participant={p} onGoalDataLoaded={this.props.onGoalDataLoaded}/>
                    </TableRow>
                )}
            </TableBody>
        );
    }
}

export default withRouter(withStyles(styles)(ParticipantListBody));



// WEBPACK FOOTER //
// ./src/de/ergovia/components/participants/ParticipantListBody.jsx